var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrowAggrep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228 343.1",
    style: {
      enableBackground: "new 0 0 228 343.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#25907B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.4,1.6c-0.3,0.3-0.6,0.6-0.9,0.9L8.3,99.6c-3.2,2.9-3.4,7.9-0.4,11.1c1.5,1.6,3.5,2.5,5.6,2.5h52.2 v125.9c0,4.7,1,9.9,5.2,9.9h83.6c5.3-0.6,9.6-4.7,10.4-9.9V113.2h47c3.1-0.1,5.9-1.9,7.3-4.7v-3.1c-0.1-2.2-1-4.2-2.6-5.7 L118,2.5C115.6-0.4,111.3-0.8,108.4,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.1,272.6c0,4.3,3.5,7.8,7.8,7.8h83.6c4.3,0,7.8-3.5,7.8-7.8c0-4.3-3.5-7.8-7.8-7.8H71 C66.6,264.7,63.1,268.2,63.1,272.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.1,303.9c0,4.3,3.5,7.8,7.8,7.8h83.6c4.3,0,7.8-3.5,7.8-7.8s-3.5-7.8-7.8-7.8H71 C66.6,296.1,63.1,299.6,63.1,303.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.1,335.3c0,4.3,3.5,7.8,7.8,7.8h83.6c4.3,0,7.8-3.5,7.8-7.8s-3.5-7.8-7.8-7.8H71 C66.6,327.4,63.1,330.9,63.1,335.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowAggrep);
export default __webpack_public_path__ + "static/media/up_arrow_aggrep.e67cf76c76c7fe6694746c0cd124033a.svg";
export { ForwardRef as ReactComponent };